import React, {useEffect} from "react";
import AppButton from "@common/components/app-button";
import {XMarkIcon} from "@heroicons/react/20/solid";
import {useArticleForm} from "../../hooks/use-article-form.hook";
import SpecialistProfileImage from "../../../specialists/components/specialist-profile-image";

interface SelectedArticleSpecialistTagProps {
    id: string;
    fullName: string;
    onRemove?: () => void;
}

const SelectedArticleSpecialistTag = (props: SelectedArticleSpecialistTagProps) => {
    const {id, fullName, onRemove} = props;
    const {form} = useArticleForm();

    const handleRemove = () => {
        if (onRemove) {
            onRemove();
            return;
        }
        const selected = form.getValues("specialists") ?? [];
        form.setValue(
            "specialists",
            selected.filter((s: any) => s.id !== id),
            {shouldDirty: true, shouldValidate: true}
        );
    };

    return (
        <div className="mr-2 mb-2 inline-block h-[32px]">
            <AppButton
                className="cursor-auto !w-fit h-[32px] !p-0 !pl-1 bg-surface-level-1 hover:bg-on-surface/5 border border-outline rounded-lg text-sm font-semibold">
                <div className="flex items-center gap-2 h-[32px] max-h-[32px]">
                    <SpecialistProfileImage
                        key={id}
                        specialistId={id}
                        specialistName={fullName}
                        className="w-6 h-6"
                    />
                    <span className="px-1">{fullName}</span>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRemove();
                        }}
                        className="w-fit h-fit cursor-pointer hover:bg-on-surface/10 rounded-2xl p-1">
                        <XMarkIcon className="w-6 h-6 min-w-6"/>
                    </div>
                </div>
            </AppButton>
        </div>
    )
}

export default SelectedArticleSpecialistTag


